
import {
  GET_COMMISSION_REPORT_REQUEST,
  GET_COMMISSION_REPORT_SUCCESS,
  GET_COMMISSION_REPORT_ERROR,
} from "../actions/types";

export const commissionReport = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMMISSION_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_COMMISSION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_COMMISSION_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};